export const racesGetMeetings = 'races:getmeetings';
export const eventListCommand = 'event:list';
export const racesGetNextRaces = 'races:getnextraces';
export const racesGetFromMeeting = 'races:getfrommeeting';
export const racesGet = 'races:get';
export const eventRetrieve = 'event:retrieve';
export const eventTrending = 'event:trending';
export const eventStreamGetCommand = 'event:stream:get';
export const offeringGetOfferTypes = 'offering:getoffertypes';
export const offeringGetOutcomes = 'offering:getoutcomes';
export const offeringGetOfferTypeGroups = 'offering:getoffertypegroups';
export const eventGetCommand = 'event:get';
export const offeringUnsubscribe = 'offering:unsubscribe';
export const offeringSubscribe = 'offering:subscribe';
export const competitionsGet = 'competitions:get';
export const eventSearch = 'event:search';
